"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportToPdf = exports.exportToXlsx = exports.exportSelectedToCsv = exports.exportToCsv = exports.buildCsvContent = exports.buildSelectedExportRows = exports.buildExportRows = exports.sortTxns = exports.getTxnMemoForRow = exports.getTxnTagsValue = exports.getTagNames = exports.injectOtherBucket = exports.flattenNodesForView = exports.mapGroupRecordToNodes = exports.getTxnField = exports.getNextExpandedKeys = exports.csvEscape = exports.formatAmount = exports.toNumber = void 0;
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const types_1 = require("./types");
// ── Internal helpers ──
const isImmutableTag = (tag) => typeof (tag === null || tag === void 0 ? void 0 : tag.get) === 'function';
// eslint-disable-next-line @typescript-eslint/comma-dangle
const toArray = (value) => {
    if (!value)
        return [];
    if (typeof value.toArray === 'function')
        return value.toArray();
    return Array.isArray(value) ? value : [];
};
const getTagId = (tag) => {
    if (typeof tag === 'string' || typeof tag === 'number')
        return tag;
    return isImmutableTag(tag) ? tag.get('id') : tag.id;
};
const getTagName = (tag) => {
    if (typeof tag === 'string' || typeof tag === 'number')
        return undefined;
    return isImmutableTag(tag) ? tag.get('name') : tag.name;
};
const resolveTagName = (tag, tagsById) => {
    var _a, _b, _c, _d, _e, _f;
    if (!tag)
        return null;
    const name = getTagName(tag);
    if (name)
        return name;
    const id = getTagId(tag);
    return id != null ? ((_f = (_c = (_b = (_a = tagsById === null || tagsById === void 0 ? void 0 : tagsById.get) === null || _a === void 0 ? void 0 : _a.call(tagsById, String(id))) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_e = (_d = tagsById === null || tagsById === void 0 ? void 0 : tagsById.get) === null || _d === void 0 ? void 0 : _d.call(tagsById, id)) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : null) : null;
};
// ── General utilities ──
const toNumber = (val) => {
    const num = typeof val === 'number' ? val : Number(val);
    return Number.isFinite(num) ? num : 0;
};
exports.toNumber = toNumber;
const formatAmount = (amount) => (0, exports.toNumber)(amount).toFixed(2);
exports.formatAmount = formatAmount;
const csvEscape = (val) => {
    const escaped = val.replace(/"/g, '""');
    return /[",\n]/.test(val) ? `"${escaped}"` : escaped;
};
exports.csvEscape = csvEscape;
const getNextExpandedKeys = (prev, key, defaultExpanded = true) => { var _a; return (Object.assign(Object.assign({}, prev), { [key]: !((_a = prev[key]) !== null && _a !== void 0 ? _a : defaultExpanded) })); };
exports.getNextExpandedKeys = getNextExpandedKeys;
// eslint-disable-next-line @typescript-eslint/comma-dangle
const getTxnField = (txn, field) => typeof (txn === null || txn === void 0 ? void 0 : txn.get) === 'function'
    ? txn.get(field)
    : txn[field];
exports.getTxnField = getTxnField;
const getSplitItemForRow = (txn, categoryId) => {
    var _a, _b, _c;
    if (categoryId == null)
        return null;
    const splitItems = (_b = ((_a = (0, exports.getTxnField)(txn, 'split')) !== null && _a !== void 0 ? _a : undefined)) === null || _b === void 0 ? void 0 : _b.items;
    if (!splitItems)
        return null;
    const items = toArray(splitItems);
    if (items.length === 0)
        return null;
    return (_c = items.find((item) => {
        const record = item;
        const coa = (typeof record.get === 'function' ? record.get('coa') : item === null || item === void 0 ? void 0 : item.coa);
        return (coa === null || coa === void 0 ? void 0 : coa.id) != null && (coa.id === categoryId || String(coa.id) === String(categoryId));
    })) !== null && _c !== void 0 ? _c : null;
};
// ── Grouping ──
const isUncategorized = (node) => { var _a; return ((_a = node.groupKey) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'uncategorized'; };
const sortGroupsAlphabetically = (nodes) => nodes.sort((leftNode, rightNode) => {
    if (isUncategorized(leftNode) !== isUncategorized(rightNode))
        return isUncategorized(leftNode) ? -1 : 1;
    return (leftNode.groupKey || '').localeCompare(rightNode.groupKey || '', undefined, { sensitivity: 'base' });
});
const mapGroupRecordToNodes = (groupRecord) => {
    if (!groupRecord)
        return [];
    const nodes = Object.values(groupRecord).map((node) => (Object.assign(Object.assign({}, node), { subgroups: (0, exports.mapGroupRecordToNodes)(node.subgroups) })));
    return sortGroupsAlphabetically(nodes);
};
exports.mapGroupRecordToNodes = mapGroupRecordToNodes;
const flattenNodesForView = (nodes, maxDepth) => {
    const flattenedNodes = [];
    const walk = (items, depth) => {
        items.forEach((item) => {
            flattenedNodes.push(Object.assign(Object.assign({}, item), { depth }));
            const children = Array.isArray(item.subgroups) ? item.subgroups : [];
            if (children.length > 0 && depth < maxDepth)
                walk(children, depth + 1);
        });
    };
    walk(nodes, 0);
    return flattenedNodes;
};
exports.flattenNodesForView = flattenNodesForView;
const collectTxnIds = (nodes) => {
    const ids = new Set();
    nodes.forEach((node) => {
        var _a;
        (_a = node.txns) === null || _a === void 0 ? void 0 : _a.forEach((txn) => {
            const id = (0, exports.getTxnField)(txn, 'id');
            if (id)
                ids.add(id);
        });
    });
    return ids;
};
/**
 * Computes the corrected total and filtered transactions for an "Other" bucket.
 * Needed because duplicate children carry the parent's full total/txns,
 * but "Other" should only reflect txns not covered by real siblings.
 */
const buildOtherBucketData = (node, realChildren) => {
    const realChildTxnIds = collectTxnIds(realChildren);
    const txns = node.txns.filter((txn) => {
        const id = (0, exports.getTxnField)(txn, 'id');
        return !id || !realChildTxnIds.has(id);
    });
    const total = (node.total || 0) - realChildren.reduce((acc, c) => acc + (c.total || 0), 0);
    return { txns, total };
};
/** Renames duplicate-label children to "Other <Parent>" with corrected data. */
const injectOtherBucket = (nodes) => nodes.map((node) => {
    const children = Array.isArray(node.subgroups) ? node.subgroups : [];
    if (children.length === 0 || !node.txns || node.txns.size === 0)
        return node;
    const realChildren = children.filter((child) => child.groupKey !== node.groupKey);
    // No real children — mark as leaf parent for Category Summary collapse
    if (realChildren.length === children.length)
        return node;
    if (realChildren.length === 0)
        return Object.assign(Object.assign({}, node), { leafParent: true });
    const other = buildOtherBucketData(node, realChildren);
    if (other.txns.size === 0)
        return node;
    // Rename duplicate children to "Other <Parent>" with corrected totals/txns
    const updatedChildren = children.map((child) => {
        if (child.groupKey !== node.groupKey)
            return child;
        const otherKey = `Other ${node.groupKey}`;
        const otherId = node.categoryId ? `${node.categoryId}__other` : `other__${node.groupKey}`;
        return Object.assign(Object.assign({}, child), { groupKey: otherKey, categoryId: otherId, total: other.total, txns: other.txns, subgroups: [{ groupKey: otherKey, categoryId: otherId, total: other.total, txns: other.txns, subgroups: [] }] });
    });
    return Object.assign(Object.assign({}, node), { txns: undefined, subgroups: sortGroupsAlphabetically(updatedChildren) });
});
exports.injectOtherBucket = injectOtherBucket;
// ── Tags ──
const getTagNames = (tagsValue, tagsById) => toArray(tagsValue)
    .map((tag) => resolveTagName(tag, tagsById))
    .filter(Boolean)
    .join('/');
exports.getTagNames = getTagNames;
const getTxnTagsValue = (txn, categoryId) => {
    var _a, _b;
    const directTags = (0, exports.getTxnField)(txn, 'tags');
    if (directTags && toArray(directTags).length > 0)
        return directTags;
    const splitItems = (_b = ((_a = (0, exports.getTxnField)(txn, 'split')) !== null && _a !== void 0 ? _a : undefined)) === null || _b === void 0 ? void 0 : _b.items;
    if (!splitItems)
        return directTags;
    const items = toArray(splitItems);
    if (categoryId != null) {
        const matched = getSplitItemForRow(txn, categoryId);
        if (matched) {
            const record = matched;
            return (typeof record.get === 'function' ? record.get('tags') : matched.tags);
        }
    }
    return items.flatMap((item) => toArray(item === null || item === void 0 ? void 0 : item.tags));
};
exports.getTxnTagsValue = getTxnTagsValue;
const getTxnMemoForRow = (txn, categoryId) => {
    if (categoryId != null) {
        const matched = getSplitItemForRow(txn, categoryId);
        if (matched) {
            const record = matched;
            const splitMemo = (typeof record.get === 'function' ? record.get('memo') : matched.memo);
            if (splitMemo)
                return splitMemo;
        }
    }
    return (0, exports.getTxnField)(txn, 'memo') || '';
};
exports.getTxnMemoForRow = getTxnMemoForRow;
// ── Sorting ──
const getTxnNum = (txn) => {
    var _a, _b, _c, _d, _e, _f;
    return String((_f = (_d = (_c = (_b = (_a = (0, exports.getTxnField)(txn, 'checkNumber')) !== null && _a !== void 0 ? _a : (0, exports.getTxnField)(txn, 'checkNum')) !== null && _b !== void 0 ? _b : (0, exports.getTxnField)(txn, 'num')) !== null && _c !== void 0 ? _c : (0, exports.getTxnField)(txn, 'number')) !== null && _d !== void 0 ? _d : (_e = (0, exports.getTxnField)(txn, 'check')) === null || _e === void 0 ? void 0 : _e.number) !== null && _f !== void 0 ? _f : '').trim();
};
const getTxnSortValue = (txn, sortBy, tagsById, getAmount) => {
    switch (sortBy) {
        case 'date': {
            const millis = luxon_1.DateTime.fromISO((0, exports.getTxnField)(txn, 'postedOn') || '').toMillis();
            return Number.isFinite(millis) ? millis : 0;
        }
        case 'num': return getTxnNum(txn).toLowerCase();
        case 'description': return ((0, exports.getTxnField)(txn, 'payee') || '').trim().toLowerCase();
        case 'memo': return ((0, exports.getTxnField)(txn, 'memo') || '').trim().toLowerCase();
        case 'tag': return (0, exports.getTagNames)((0, exports.getTxnTagsValue)(txn), tagsById).trim().toLowerCase();
        case 'clr': return ((0, exports.getTxnField)(txn, 'state') || '').trim().toLowerCase();
        case 'amount': return getAmount ? getAmount(txn) : (0, exports.toNumber)((0, exports.getTxnField)(txn, 'amount'));
        default: return 0;
    }
};
const sortTxns = (txns, sortBy, sortDirection, tagsById, getAmount) => {
    const directionMultiplier = sortDirection === 'asc' ? 1 : -1;
    const sortedTransactions = txns.toArray().sort((leftTxn, rightTxn) => {
        const leftValue = getTxnSortValue(leftTxn, sortBy, tagsById, getAmount);
        const rightValue = getTxnSortValue(rightTxn, sortBy, tagsById, getAmount);
        if (typeof leftValue === 'number' && typeof rightValue === 'number') {
            return directionMultiplier * (leftValue - rightValue);
        }
        return directionMultiplier * String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true, sensitivity: 'base' });
    });
    return (0, immutable_1.List)(sortedTransactions);
};
exports.sortTxns = sortTxns;
// ── Export rows ──
const mkExportRow = (row) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ({
        Date: (_a = row.Date) !== null && _a !== void 0 ? _a : '',
        Account: (_b = row.Account) !== null && _b !== void 0 ? _b : '',
        'Check #': (_c = row['Check #']) !== null && _c !== void 0 ? _c : '',
        Payee: (_d = row.Payee) !== null && _d !== void 0 ? _d : '',
        Memo: (_e = row.Memo) !== null && _e !== void 0 ? _e : '',
        Tag: (_f = row.Tag) !== null && _f !== void 0 ? _f : '',
        Clr: (_g = row.Clr) !== null && _g !== void 0 ? _g : '',
        Amount: (_h = row.Amount) !== null && _h !== void 0 ? _h : '',
    });
};
const txnToExportRow = (txn, tagsById, getAccountString, formatAmountFn, getAmount) => {
    const postedOn = (0, exports.getTxnField)(txn, 'postedOn');
    return mkExportRow({
        Date: postedOn ? luxon_1.DateTime.fromISO(postedOn).toFormat('MM/dd/yyyy') : '',
        Account: getAccountString((0, exports.getTxnField)(txn, 'accountId')),
        'Check #': getTxnNum(txn),
        Payee: (0, exports.getTxnField)(txn, 'payee') || '',
        Memo: (0, exports.getTxnField)(txn, 'memo') || '',
        Tag: (0, exports.getTagNames)((0, exports.getTxnTagsValue)(txn), tagsById),
        Clr: ((0, exports.getTxnField)(txn, 'state') || '').toString(),
        Amount: formatAmountFn(getAmount ? getAmount(txn) : (0, exports.toNumber)((0, exports.getTxnField)(txn, 'amount'))),
    });
};
const buildExportRows = (params) => {
    var _a, _b;
    const { incomeRows, expenseRows, incomeReport, expenseReport, isTransactionsView, sortBy, sortDirection, tagsById, getTxnAmountForRow, getAccountString, formatAmount: fmt, } = params;
    const rows = [];
    const addSection = (label, sectionRows) => {
        const sectionTotal = sectionRows
            .filter((row) => row.depth === 0)
            .reduce((total, row) => total + (row.total || 0), 0);
        rows.push(mkExportRow({ Date: label, Amount: fmt(sectionTotal) }));
        let prev = null;
        sectionRows.forEach((row) => {
            const hasChildren = Array.isArray(row.subgroups) && row.subgroups.length > 0;
            const isDuplicate = prev && row.depth === prev.depth + 1 && row.groupKey === prev.groupKey;
            const addTxnRows = () => {
                if (isTransactionsView && row.txns && row.txns.size > 0) {
                    (0, exports.sortTxns)(row.txns, sortBy, sortDirection, tagsById, (txn) => getTxnAmountForRow(txn, row))
                        .forEach((txn) => rows.push(txnToExportRow(txn, tagsById, getAccountString, fmt, (currentTxn) => getTxnAmountForRow(currentTxn, row))));
                }
            };
            if (isDuplicate && !hasChildren) {
                addTxnRows();
                prev = { groupKey: row.groupKey, depth: row.depth };
                return;
            }
            rows.push(mkExportRow({ Date: `${'  '.repeat(row.depth)}${row.groupKey || ''}`, Amount: fmt(row.total || 0) }));
            addTxnRows();
            prev = { groupKey: row.groupKey, depth: row.depth };
        });
    };
    addSection('INCOME', incomeRows);
    addSection('EXPENSES', expenseRows);
    rows.push(mkExportRow({
        Date: 'OVERALL...',
        Amount: fmt((((_a = incomeReport === null || incomeReport === void 0 ? void 0 : incomeReport.get('rawReport')) === null || _a === void 0 ? void 0 : _a.get('total')) || 0) + (((_b = expenseReport === null || expenseReport === void 0 ? void 0 : expenseReport.get('rawReport')) === null || _b === void 0 ? void 0 : _b.get('total')) || 0)),
    }));
    return rows;
};
exports.buildExportRows = buildExportRows;
const buildSelectedExportRows = (params) => {
    const { selectedTxns, sortBy, sortDirection, tagsById, getAccountString, formatAmount: fmt } = params;
    if (selectedTxns.size === 0)
        return [];
    return (0, exports.sortTxns)((0, immutable_1.List)(selectedTxns.toArray()), sortBy, sortDirection, tagsById)
        .toArray()
        .map((txn) => txnToExportRow(txn, tagsById, getAccountString, (value) => fmt((0, exports.toNumber)(value))));
};
exports.buildSelectedExportRows = buildSelectedExportRows;
const buildCsvContent = (rows, columns) => {
    const header = columns.join(',');
    const body = rows.map((row) => columns.map((column) => { var _a; return (0, exports.csvEscape)(((_a = row[column]) !== null && _a !== void 0 ? _a : '').toString()); }).join(',')).join('\n');
    return `${header}\n${body}\n`;
};
exports.buildCsvContent = buildCsvContent;
// ── File download ──
const downloadBlob = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 2000);
};
const makeFileName = (datasetName, suffix, ext) => `${datasetName || 'Dataset'}_ItemizedTransactions${suffix}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.${ext}`;
const exportToCsv = (rows, datasetName) => {
    downloadBlob(new Blob([(0, exports.buildCsvContent)(rows, types_1.EXPORT_COLUMNS)], { type: 'text/csv;charset=utf-8' }), makeFileName(datasetName, '', 'csv'));
};
exports.exportToCsv = exportToCsv;
const exportSelectedToCsv = (rows, datasetName) => {
    if (rows.length === 0)
        return;
    downloadBlob(new Blob([(0, exports.buildCsvContent)(rows, types_1.EXPORT_COLUMNS)], { type: 'text/csv;charset=utf-8' }), makeFileName(datasetName, '_Selected', 'csv'));
};
exports.exportSelectedToCsv = exportSelectedToCsv;
const exportToXlsx = (rows, datasetName) => __awaiter(void 0, void 0, void 0, function* () {
    const writeXlsxFile = (yield Promise.resolve().then(() => __importStar(require('write-excel-file')))).default;
    const schema = types_1.EXPORT_COLUMNS.map((column) => ({
        column,
        type: String,
        value: (val) => val[column],
        align: (column === 'Amount' ? 'right' : 'left'),
    }));
    yield writeXlsxFile(rows, { schema, fileName: makeFileName(datasetName, '', 'xlsx') });
});
exports.exportToXlsx = exportToXlsx;
const exportToPdf = (rows, datasetName, dateRangeLabel) => __awaiter(void 0, void 0, void 0, function* () {
    const { jsPDF } = yield Promise.resolve().then(() => __importStar(require('jspdf')));
    yield Promise.resolve().then(() => __importStar(require('jspdf-autotable')));
    // eslint-disable-next-line new-cap
    const doc = new jsPDF('l', 'pt', 'a4');
    doc.setFontSize(14);
    doc.text('Itemized Transactions', 40, 40);
    doc.setFontSize(10);
    doc.text(dateRangeLabel, 40, 58);
    doc.autoTable({
        head: [types_1.EXPORT_COLUMNS],
        body: rows.map((row) => types_1.EXPORT_COLUMNS.map((column) => row[column] || '')),
        startY: 70,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [245, 245, 245], textColor: 20 },
        theme: 'grid',
    });
    doc.save(makeFileName(datasetName, '', 'pdf'));
});
exports.exportToPdf = exportToPdf;
